import { initFirebase } from "@version2/ui-package";
import { env } from "../../Consts/config";
import { fetchRemoteConfig } from "./remote_config";

const initFirebaseApp = async () => {
  return initFirebase({
    config: {
      apiKey: env.FIREBASE_API_KEY ?? "",
      authDomain: env.FIREBASE_AUTH_DOMAIN ?? "",
      projectId: env.FIREBASE_PROJECT_ID ?? "",
      storageBucket: env.FIREBASE_STORAGE_BUCKET ?? "",
      messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID ?? "",
      appId: env.FIREBASE_APP_ID ?? "",
      measurementId: env.FIREBASE_MEASUREMENT_ID ?? "",
      databaseURL: env.FIREBASE_DATABASE_URL ?? "",
    },
    recaptchaSiteKey: env.RECAPTCHA_SITE_KEY,
    isDebug: env.IS_DEBUG,
    fetchRemoteConfig,
  });
};

export { initFirebaseApp as initFirebase };
